import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import TestimonialCard from "./TestimonialCard";

const testimonialData = [
  {
    image: "https://www.qahe.org/wp-content/uploads/2023/09/ISO17011-2017-520-x330.jpg",
    name: "রনি তালুকদার ",
    class: "Seven",
    school: "Residential School and College",
    feedback:
      `"আমার ছেলে সম্প্রতি ‘রিভাইভ টেস্ট’ দিয়েছে এবং এই টেস্টর মাধ্যমে ওর মানসিক স্বাস্থ্য, আবেগ নিয়ন্ত্রণ, আত্মবিশ্বাস ও মনোযোগের স্তর সম্পর্কে অনেক গুরুত্বপূর্ণ তথ্য জানতে পেরেছি। আমরা এখন বুঝতে পারছি, আমার ছেলের কোন দিকগুলোতে বাড়তি সহানুভূতি, সহায়তা বা গাইডেন্স দরকার। এই টেস্টের পর আমরা ওর দৈনন্দিন রুটিনে কিছু ইতিবাচক পরিবর্তন এনেছি, যার প্রভাব ইতিমধ্যেই দেখতে পাচ্ছি।`
  },
  {
    image: "https://www.qahe.org/wp-content/uploads/2023/08/officialgafm.png",
    name: "কামরুল হাসান ",
    class: "Eight",
    school: "City Girls' School",
    feedback:
      `"আমার মেয়ে অদ্রিজা খুব চঞ্চল স্বভাবের। ওর মনোযোগে সমস্যা হচ্ছে বলে আমরা ‘রিভাইভ টেস্ট’ করানোর সিদ্ধান্ত নিই। এই টেস্টে ওর আবেগের ওঠানামা, চাপ সহ্য করার ক্ষমতা এবং আত্মবিশ্বাসের জায়গাগুলো স্পষ্টভাবে উঠে এসেছে। মাত্র কয়েক সপ্তাহেই আমরা অদ্রিজার মধ্যে ইতিবাচক পরিবর্তন লক্ষ্য করছি। এই পরীক্ষাটি না করালে হয়তো এতদিনেও বুঝতাম না ঠিক কোথায় সমস্যার গোড়াটা। এটা নিঃসন্দেহে একটি কার্যকরী ও সময়োপযোগী উদ্যোগ।"`
  },
  {
    image: "https://www.qahe.org/wp-content/uploads/2024/07/AAQR-QAHE-website.png",
    name: "উম্মে কুলসুম",
    class: "Nine",
    school: "Metropolitan High School",
    feedback:
      `"আমরা ‘রিভাইভ টেস্ট’ সম্পর্কে জানতে পেরে নিহানকে এটি দিতে পাঠাই ও কিছুদিন ধরে পড়াশোনায় উৎসাহ হারাচ্ছিল, কথা কম বলছিল, এবং মাঝে মাঝে অকারণে রেগে যেত। রিপোর্টে উঠে এসেছে যে ওর ভেতরে চাপ জমে আছে, এবং সেটা প্রকাশ করার উপায় পাচ্ছে না। টেস্টের পর আমরা পেশাদার কাউন্সেলিং শুরু করি এবং কিছু সময় কাটানোর পারিবারিক রুটিন গঠন করি। আজ আমি গর্বের সঙ্গে বলছি, নিহান আবার আগের মতো প্রাণবন্ত হয়ে উঠছে। এই টেস্টের জন্যই আমরা ওর সমস্যাটা ধরতে পেরেছি। অভিভাবক হিসেবে আমি অত্যন্ত কৃতজ্ঞ।"`
  },
  {
    image: "https://www.qahe.org/wp-content/uploads/2023/07/14.jpg",
    name: "জাকারিয়া হোসাইন ",
    class: "Ten",
    school: "National English School",
    feedback:
      `"আমি আমার মেয়ের জন্য ‘চিলড্রেন রিভাইভ টেস্ট’ করাই শুধুমাত্র জানতে চেয়েছিলাম ও মানসিকভাবে ঠিক আছে কি না। কখনো কখনো ও খুব চুপচাপ থাকে, আবার হঠাৎ খুব আবেগপ্রবণ হয়ে পড়ে। টেস্টের রিপোর্টে ওর ভেতরের সংবেদনশীলতা, নিরাপত্তার অভাব, এবং কিছু ভয় স্পষ্ট হয়ে উঠে আসে। এরপর আমরা ছোট ছোট ধাপে ওর সাথে বেশি সময় কাটানো, গল্প বলা, এবং পজিটিভ রিওয়ার্ড পদ্ধতি অনুসরণ করতে শুরু করি।`
  }
];

const Testimonial = () => {
  return (
    <div className="w-full bg-[#00294b] flex justify-center items-center sm:py-[5rem] py-[4rem]">
      <div className="container flex flex-col items-center justify-center gap-4 px-4 sm:px-0">
        <h1 className="sm:text-4xl text-3xl font-bold text-white text-center">
          কেন QS Academy <span className="text-[#22BEFF]">শিক্ষার্থীদের</span> পছন্দের শীর্ষে
        </h1>

        <div className="sm:mt-[5rem] mt-[3rem] w-full">
          <Swiper
            className="mySwiper"
            modules={[Autoplay]}
            autoplay={{ delay: 3000,disableOnInteraction: false}}
            speed={800}
            loop
            spaceBetween={30}
            breakpoints={{
              320: {
                slidesPerView: 1
              },
              640: {
                slidesPerView: 2
              },
              1024: {
                slidesPerView: 2
              },
              1280: {
                slidesPerView: 3
              }
            }}
          >
            {testimonialData.map((item, idx) => (
              <SwiperSlide key={idx}>
                <TestimonialCard {...item} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
